<div class="reset-password">
  <div class="form-wrapper">
    @if (headerImage) {
      <img class="brand-logo" [src]="transform(headerImage)" [alt]="'accessibility_alt_brand_logo_img' | translate" />
    }
    @if (!(isSubmitted && isResetted)) {
      <div>
        <span class="modal-title">{{ 'resetpwd_title' | translate }}</span>
        <form class="reset-password-form" [formGroup]="resetPwdForm" (ngSubmit)="resetPwd()">
          <mat-form-field class="password-input">
            <input
              type="password"
              formControlName="newPassword"
              matInput
              class="form-control"
              placeholder="{{ 'resetpwd_placeholder_newpwd' | translate }}"
              autocomplete="new-password"
              />
          </mat-form-field>
          @if (formControls.newPassword.errors) {
            <mat-error>
              @for (errorMessage of getErrorMessageNewPassword(); track errorMessage) {
                <div>
                  {{ errorMessage | translate }}
                </div>
              }
            </mat-error>
          }
          <mat-form-field class="password-input">
            <input
              type="password"
              formControlName="confirmNewPassword"
              matInput
              placeholder="{{ 'resetpwd_placeholder_confirmpwd' | translate }}"
              autocomplete="new-password"
              />
          </mat-form-field>
          @if (formControls.confirmNewPassword.errors) {
            <mat-error>
              @for (errorMessage of getErrorMessageConfirmNewPassword(); track errorMessage) {
                <div>
                  {{ errorMessage | translate }}
                </div>
              }
            </mat-error>
          }
          <button mat-flat-button color="primary" [disabled]="isSubmitted && isResetted">
            {{ 'resetpwd_button' | translate }}
          </button>
          @if (isSubmitted && error) {
            <div style="width: 100%">
              <app-alert status="error" [message]="error.errorKey | translate"></app-alert>
            </div>
          }
        </form>
      </div>
    } @else {
      <app-alert status="success" [message]="'resetpwd_message_success' | translate"></app-alert>
    }
  </div>
</div>
